import React from 'react';
import { BookOpenCheck, CalendarCheck2, CircleAlert, UserRoundPlus, Users } from 'lucide-react';
import { Card } from '../../../components/ui/Card';

interface ClassLessonSummaryCardsProps {
  studentsCount: number;
  visitorsCount: number;
  attendanceAverage: string;
  lessonsCompleted: number;
  recurringAbsenteesCount: number;
}

const ClassLessonSummaryCards: React.FC<ClassLessonSummaryCardsProps> = ({
  studentsCount,
  visitorsCount,
  attendanceAverage,
  lessonsCompleted,
  recurringAbsenteesCount,
}) => {
  const kpis = [
    {
      label: 'Alunos vinculados',
      value: String(studentsCount),
      icon: Users,
      cardTone: 'border-slate-200 bg-white',
      tone: 'bg-sky-100 text-sky-700 ring-sky-200',
      labelTone: 'text-sky-700',
      valueTone: 'text-sky-950',
    },
    {
      label: 'Visitantes',
      value: String(visitorsCount),
      icon: UserRoundPlus,
      cardTone: 'border-slate-200 bg-white',
      tone: 'bg-violet-100 text-violet-700 ring-violet-200',
      labelTone: 'text-violet-700',
      valueTone: 'text-violet-950',
    },
    {
      label: 'Média de presença',
      value: attendanceAverage,
      icon: CalendarCheck2,
      cardTone: 'border-slate-200 bg-white',
      tone: 'bg-emerald-100 text-emerald-700 ring-emerald-200',
      labelTone: 'text-emerald-700',
      valueTone: 'text-emerald-950',
    },
    {
      label: 'Lições ministradas',
      value: `${lessonsCompleted}/13`,
      icon: BookOpenCheck,
      cardTone: 'border-slate-200 bg-white',
      tone: 'bg-amber-100 text-amber-700 ring-amber-200',
      labelTone: 'text-amber-700',
      valueTone: 'text-amber-950',
    },
    {
      label: 'Alertas de faltas',
      value: String(recurringAbsenteesCount),
      icon: CircleAlert,
      cardTone: 'border-slate-200 bg-white',
      tone: 'bg-rose-100 text-rose-700 ring-rose-200',
      labelTone: 'text-rose-700',
      valueTone: 'text-rose-950',
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3">
      {kpis.map(({ label, value, icon: Icon, tone, cardTone, labelTone, valueTone }) => (
        <Card key={label} className={`overflow-hidden p-4 shadow-sm ${cardTone}`}>
          <div className="flex items-center gap-3">
            <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl ring-1 ${tone}`}>
              <Icon size={20} />
            </div>
            <div className="min-w-0 space-y-3">
              <span className={`block text-[11px] font-semibold uppercase tracking-[0.14em] ${labelTone}`}>{label}</span>
              <p className={`text-3xl font-bold leading-none ${valueTone}`}>{value}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default ClassLessonSummaryCards;
